// Friendly text for the QR Auto-Purchase codes (see QR-AUTO-PURCHASE-SPEC.md §1c / §1d).
// Shared by the QR Scan Log and Pending Purchases pages.

export const QR_SOURCE_AUTO = "QR_AUTO";

export const QR_REVIEW_REASON_LABELS = {
    NO_EMPTY_WEIGHT: "Vehicle empty weight not set",
    WEIGHT_NOT_STABLE: "Weight did not settle",
    CAMERA_FAILED: "Photo could not be taken",
    NET_WEIGHT_INVALID: "Net weight is zero or negative",
    SUPPLIER_NOT_FOUND: "Supplier not found",
    ITEM_NOT_FOUND: "Product not found",
    MULTIPLE_PENDING: "More than one pending purchase for this vehicle",
    WEIGHBRIDGE_MISMATCH: "Scanned at a different weighbridge",
    WEIGHT_NOT_DROPPED: "Returned without unloading?",
    PROCESSING_ERROR: "Something went wrong while processing",
    NOT_ON_SCALE: "Truck was not on the weighbridge",
    WEIGHBRIDGE_ERROR: "Weighbridge did not send a weight",
};

// label + bootstrap colour for each scan outcome
export const QR_OUTCOME_LABELS = {
    QUEUED: { label: "Waiting", color: "secondary" },
    PROCESSING: { label: "Weighing…", color: "info" },
    CREATED: { label: "Purchase created", color: "success" },
    STEP1_SAVED: { label: "Loaded weight saved", color: "primary" },
    STEP2_COMPLETED: { label: "Purchase completed", color: "success" },
    DRAFT: { label: "Saved - needs review", color: "warning" },
    IGNORED_DUPLICATE: { label: "Repeat scan ignored", color: "secondary" },
    UNKNOWN_VEHICLE: { label: "Vehicle not set up", color: "dark" },
    DISABLED_VEHICLE: { label: "Vehicle switched off", color: "dark" },
    NOT_ON_SCALE: { label: "No vehicle on the scale", color: "warning" },
    BUSY: { label: "Weighbridge busy", color: "warning" },
    ERROR: { label: "Error", color: "danger" },
};

export const QR_STEP_LABELS = {
    STEP1: "Step 1 (loaded)",
    STEP2: "Step 2 (empty)",
    ONE_STEP: "1-step",
};

export const QR_PURCHASE_TYPE_LABELS = {
    ONE_STEP: "1-step",
    TWO_STEP: "2-step",
};

export function reviewReasonLabel(code) {
    return QR_REVIEW_REASON_LABELS[code] || code;
}

export function reviewReasonsText(reasons) {
    if (!Array.isArray(reasons) || reasons.length === 0) return "";
    return reasons.map(reviewReasonLabel).join(", ");
}

export function outcomeInfo(outcome) {
    return QR_OUTCOME_LABELS[outcome] || { label: outcome || "-", color: "secondary" };
}

// Badges shown on a purchase row (Pending Purchases): "QR" and "Needs review".
// Plain component (no hooks) so it is safe to render from a column formatter.
export function QrPurchaseBadges({ row }) {
    if (!row) return null;
    const isQr = row.source === QR_SOURCE_AUTO;
    const needsReview = row.needsReview === true;
    if (!isQr && !needsReview) return null;
    const reasons = reviewReasonsText(row.reviewReasons);
    return (
        <div className="d-flex flex-wrap align-items-center gap-1 mt-1">
            {isQr && (
                <span className="badge badge-light-info" title="Created automatically from a QR scan">
                    <i className="bi bi-qr-code me-1"></i>QR
                </span>
            )}
            {needsReview && (
                <span className="badge badge-light-warning" title={reasons || "Needs review"}>
                    Needs review
                </span>
            )}
            {needsReview && reasons && (
                <span className="text-muted fs-8">{reasons}</span>
            )}
        </div>
    );
}
